import React from "react";
import Backdrop from "@mui/material/Backdrop";

import Text from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";

export default function MainBackdrop({ open }) {
  return (
    <div>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        invisible
      >
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          gap={1}
        >
          <Box sx={{ position: "relative" }}>
            <CircularProgress
              variant="determinate"
              sx={{
                color: (theme) =>
                  theme.palette.grey[
                    theme.palette.mode === "light" ? 200 : 800
                  ],
              }}
              size={40}
              thickness={4}
              value={100}
            />
            <CircularProgress
              variant="indeterminate"
              disableShrink
              sx={{
                color: (theme) =>
                  theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
                animationDuration: "550ms",
                position: "absolute",
                left: 0,
                [`& .${circularProgressClasses.circle}`]: {
                  strokeLinecap: "round",
                },
              }}
              size={40}
              thickness={4}
            />
          </Box>
          <Box>
            <Text variant="h5" align="center" color="#fff" gutterBottom>
              Mohon tunggu
            </Text>
            <Text align="center" color="#fff">
              Kami sedang memverifikasi data anda
            </Text>
          </Box>
        </Box>
      </Backdrop>
    </div>
  );
}
